import { observer } from "mobx-react-lite"

import { ShowWhenTrue } from "@/components"
import { cn, dollars } from "@/domains/library"
import { LockRewardsTokenGroupItem } from "@/domains/lock-rewards/types"
import { TokenIcon } from "@/domains/tokens/components/token-icon"

export const BigTokenGroupCard = observer(
  ({
    tokenGroup,
    isSelected,
    onToggleSelect,
  }: {
    tokenGroup: LockRewardsTokenGroupItem
    isSelected: boolean
    onToggleSelect: () => void
  }) => {
    return (
      <div
        className={cn(
          "relative overflow-hidden p-0 text-base",
          "rounded-xl ",
          "cursor-pointer",
          isSelected ? "bg-green-700 hover:bg-green-600/80" : "bg-p500 hover:bg-p300-light",
        )}
        onClick={onToggleSelect}
      >
        <ShowWhenTrue when={tokenGroup.rewards.length > 1}>
          <div
            className={cn(
              "absolute right-1 top-1",
              "h-[20px] w-[20px] rounded-full",
              "flex items-center justify-center ",
              "text-[9px]",
              isSelected ? "text-green-100" : "text-t200",
              isSelected ? "bg-green-800" : "bg-p200",
            )}
          >
            {tokenGroup.rewards.length}
          </div>
        </ShowWhenTrue>
        <div className="flex items-center px-3 pb-2.5 pt-3">
          <TokenIcon token={tokenGroup.rewards[0]!.token} size={24} />
          <span className="ml-1.5">{tokenGroup.rewards[0]!.token.symbol}</span>
        </div>
        <div className="text-bold px-3.5 pb-2">{dollars(tokenGroup.totalValueUSD, 2)}</div>
      </div>
    )
  },
)
